import type { TDatadogErrorLog } from 'utils/datadog/types'

export const GET_WORKSPACE_JOBS_COUNT_LOG: TDatadogErrorLog = {
  from: 'src/components/DashboardModals/CreateDashboardModal/components/CreateDashboardModalSecondStep/index.jsx',
  name: 'Get Workspace Jobs Count',
  message: 'Fetch number of workspace jobs',
}

export const TOLGEE_PREFIX = 'CreateDashboardModalSecondStep'
export const MAX_DASHBOARD_DESCRIPTION_LENGTH = 140
